<template>
	<div class="summary-wrapper">

		<section class="summary" v-if="services && !loading">
			
			<div class="summary-header">
				<h2 class="summary-title">Usage</h2>
				<div class="summary-price">
					<div class="summary-grand-total">
						<span class="text">Grand Total</span>
						<span class="number">$ {{grandTotal}}</span>
						<router-link to="/console/usage" class="icon-right"></router-link>
					</div>
					<div class="summary-vcash" v-if="vCash !== '0.00'">
						Remaining free tier $ {{vCash}}
					</div>
				</div>
			</div>

			<div v-if="!loading" class="summary-content">
				<UsageSummarySmallCard v-for="(service, index) in services" :service="service" :key="index" />
			</div>

		</section>

		<section v-if="!services && loading">
			<h2 class="summary-title">Usage</h2>
			<Spinner />
		</section>

		<section v-if="!services && !loading && error">
			<ErrorAlert :error="error" />
		</section>

	</div>
</template>

<script>
import UsageSummarySmallCard from "./UsageSummarySmallCard";
import Spinner from "../shared/Spinner";
import ErrorAlert from "../shared/ErrorAlert";

export default {
	name: "UsageSummary",
	components: {
		UsageSummarySmallCard,
		Spinner,
		ErrorAlert
	},
	computed: {
		grandTotal: function () {
			return (this.grandTotalCents / 100).toFixed(2);
		},
		services: function () {
			return this.$store.getters.usage.services;
		},
		grandTotalCents: function () {
			return this.$store.getters.usage.grandTotalCents;
		},
		loading: function () {
			return this.$store.getters.loading('usage');
		},
		error: function () {
			return this.$store.getters.error('usage');
		},
		vCash: function () {
			return (this.$store.getters.virtualCash / 100).toFixed(2);
		}
	},
};
</script>